export const LEGAL_DOCS = {
    terms: {
        title: "Kullanım Koşulları",
        content: `
            <h3>1. Giriş</h3>
            <p>FinanceHub platformuna hoş geldiniz. Bu platformu kullanarak aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız.</p>
            
            <h3>2. Hizmet Kullanımı</h3>
            <p>FinanceHub, kullanıcılara finansal analiz, takip ve raporlama araçları sunar. Platformun sunduğu hizmetler sadece bilgilendirme amaçlıdır.</p>
            
            <h3>3. Hesap Güvenliği</h3>
            <p>Kullanıcılar, hesap bilgilerinin güvenliğinden kendileri sorumludur. Şüpheli bir durum fark edildiğinde derhal destek ekibiyle iletişime geçilmelidir.</p>
            
            <h3>4. Fikri Mülkiyet</h3>
            <p>Platform üzerindeki tüm içerik, logo ve yazılımlar FinanceHub'ın mülkiyetindedir ve izinsiz kopyalanamaz.</p>
            
            <h3>5. Değişiklikler</h3>
            <p>FinanceHub, bu koşulları önceden haber vermeksizin değiştirme hakkını saklı tutar.</p>
        `
    },
    privacy: {
        title: "Gizlilik Politikası",
        content: `
            <h3>1. Veri Toplama</h3>
            <p>Hizmet kalitesini artırmak amacıyla kullanıcı adı, e-posta adresi ve kullanım verileri toplanabilir.</p>
            
            <h3>2. Veri Kullanımı</h3>
            <p>Toplanan veriler, hesap yönetimi, güvenlik ve hizmet iyileştirme amaçlarıyla kullanılır. Üçüncü taraflarla pazarlama amacıyla paylaşılmaz.</p>
            
            <h3>3. Çerezler</h3>
            <p>Kullanıcı deneyimini iyileştirmek için çerezler (cookies) kullanılmaktadır. Tarayıcı ayarlarından çerezleri yönetebilirsiniz.</p>
            
            <h3>4. Veri Güvenliği</h3>
            <p>Kişisel verileriniz endüstri standardı güvenlik önlemleriyle korunmaktadır.</p>
        `
    },
    legal: {
        title: "Yasal Uyarı",
        content: `
            <h3>1. Genel Bilgilendirme</h3>
            <p>Bu platformdaki tüm veriler, piyasa koşullarına göre gecikmeli olabilir ve kesinlik taşımaz.</p>
            
            <h3>2. Yatırım Riski</h3>
            <p>Finansal piyasalarda işlem yapmak yüksek risk içerir. Kullanıcılar kendi kararlarından %100 sorumludur.</p>
            
            <h3>3. Yargı Yeri</h3>
            <p>Olası uyuşmazlıklarda yerel mahkemeler yetkilidir.</p>
        `
    },
    disclaimer: {
        title: "Sorumluluk Reddi",
        content: `
            <h3>1. Yatırım Tavsiyesi Değildir</h3>
            <p>FinanceHub tarafından sunulan hiçbir analiz, grafik veya yapay zeka sinyali yatırım tavsiyesi niteliğinde değildir.</p>
            
            <h3>2. Sorumluluk Kabulü</h3>
            <p>Kullanıcı, platform üzerinde aldığı kararlardan doğabilecek maddi/manevi zararlardan FinanceHub'ı sorumlu tutamaz.</p>
            
            <h3>3. Teknik Sorunlar</h3>
            <p>Sistemde oluşabilecek teknik aksaklıklar, veri kesintileri veya hatalı hesaplamalar nedeniyle oluşabilecek kayıplardan platform sorumlu değildir.</p>
        `
    }
};
